/**
 * Odmiana rzeczowników po liczebniku.
 *
 * Polski ma trzy formy i wybór zależy od końcówki liczby:
 *   1                      -> pojedyncza      (1 kod, 1 wpis)
 *   2-4, 22-24, 32-34...   -> mnoga           (2 kody, 23 wpisy)
 *   0, 5-21, 25-31...      -> dopełniaczowa   (5 kodów, 12 wpisów)
 *
 * Bez tego interfejs pisze "1 kodów" i "2 podejrzanych norm", co od razu
 * zdradza, że tekst składano automatem.
 */
export function odmien(n: number, poj: string, mno: string, dop: string): string {
  const a = Math.abs(Math.trunc(n));
  if (a === 1) return poj;
  const dwie = a % 100;
  const jedna = a % 10;
  if (jedna >= 2 && jedna <= 4 && !(dwie >= 12 && dwie <= 14)) return mno;
  return dop;
}

/** Liczba wraz z odmienionym rzeczownikiem, np. "3 kody". */
export function ile(n: number, poj: string, mno: string, dop: string): string {
  return `${n} ${odmien(n, poj, mno, dop)}`;
}

/** Najczęstsze rzeczowniki interfejsu — żeby nie powtarzać form w kodzie. */
export const RZECZOWNIKI = {
  wpis: ['wpis', 'wpisy', 'wpisów'],
  kod: ['kod', 'kody', 'kodów'],
  norma: ['norma', 'normy', 'norm'],
  para: ['para', 'pary', 'par'],
  pomiar: ['pomiar', 'pomiary', 'pomiarów'],
  sztuka: ['sztuka', 'sztuki', 'sztuk'],
  pracownik: ['pracownik', 'pracownicy', 'pracowników'],
  dzien: ['dzień', 'dni', 'dni'],
  zlecenie: ['zlecenie', 'zlecenia', 'zleceń'],
  pozycja: ['pozycja', 'pozycje', 'pozycji'],
  zmiana: ['zmiana', 'zmiany', 'zmian'],
  miesiac: ['miesiąc', 'miesiące', 'miesięcy'],
  operacja: ['operacja', 'operacje', 'operacji'],
} as const;

type Klucz = keyof typeof RZECZOWNIKI;

/** Skrót: policz(3, 'kod') -> "3 kody". */
export function policz(n: number, klucz: Klucz): string {
  const [poj, mno, dop] = RZECZOWNIKI[klucz];
  return ile(n, poj, mno, dop);
}

/** Sama forma bez liczby, np. gdy liczba jest wyróżniona typograficznie. */
export function forma(n: number, klucz: Klucz): string {
  const [poj, mno, dop] = RZECZOWNIKI[klucz];
  return odmien(n, poj, mno, dop);
}
